export default {
  caseinfo: 'Case Info',
  intro: 'This box displays key information of the judgment using AI technologies. Click to read about this feature. Comments and reports are welcome via the feedback page.',
  case_disclaimer: '* The information listed here is sourced from judgments of the entire case',
  pi: {
    title: 'PSLA details',
    background: {text:"Plaintiff's background"},
    age_accident: {text:'Age at accident'},
    age_trial:  {text:'Age at trial/assessment of damages'},
    gender: {text:'Gender'},
    male: 'Male',
    female:'Female',
    occupation_bef:{text:'Occupation before accident'},
    occupation_aft_actual:{text:'Occupation after accident'},
    injuries: {text:'Injury'},
    injury_type: {text:'Injury Severity'},
    disaster: 'Disaster',
    gross: 'Gross disability',
    substantial: 'Substantial injury',
    serious: 'Serious injury',
    nonserious: 'Less than serious',
    //treat_hospital_rcvd: {text:'Days of hospitalization',unit: '| {n} day | {n} days'}, //treat_hospital_rcvd
    //sickleave_actual: {text:'Days of sick leave',unit: '| {n} day | {n} days'}, //treat_hospital_act
    loss: {text:'Loss of amenities'},
    loss_walk: 'Loss of ability to walk or see',
    loss_limb: 'Loss of a limb or its use',
    loss_congenial_emp: 'Loss of congenial employment',
    loss_pride_pleasure: 'Loss of pride and pleasure in one’s work',
    loss_marriage: 'Loss of marriage prospects',
    loss_breakdown_family: 'Breakdown of the family',
    loss_sexual_function: 'Loss of sexual function',
    loss_sexual_interest: 'Loss of interest in sex',
    loss_give_birth: 'Loss of ability to give birth',
    loss_natural_childbirth: 'Loss of ability to give natural childbirth',
    loss_mental_ability: 'Loss of mental ability',
    loss_personality: 'Personality change',
    loss_life_expectation: 'Loss of expectation of life',
    loss_confidence_public: 'Loss of confidence in going out in the public',
    loss_grandchildren: 'Loss of pleasure in being able to look after one’s grandchildren',
    loss_children: 'Loss of pleasure in being able to play with one’s children',
    loss_pleasure_parenthood: 'Deprivation of the general pleasures of parenthood',
    loss_social_activities: 'Loss of the ability to engage in social activities, sports and hobbies',
    loss_rewarding_occupation: 'Loss of the ability to pursue a rewarding and enjoyable occupation',
    loss_family_social_pleasure: 'Loss of the pleasures of family or social life',
    comparable_cases: {text:'Comparable cases'},
    more_serious: {text:'More serious injury'},
    similar: {text:'Similar or same injury'},
    less_serious: {text:'Less serious injury'},
    level_unspecified: {text: 'Unspecified'},
    psla_amount: {text:'PSLA award amount', unit:'$ {n}'},
    treatment_type_received:{text: 'Treatment received'},
  },
  dt:{
    title: 'Drug Trafficking',
    selecthint: 'Select a defendant',
    f_charge_single: 'Charge',
    f_charge: 'Charge {0}',
    f_defendant_single: 'Defendant',
    f_defendant: 'Defendant {0}',
    charge_name: {text: 'Offence'},
    drugs: {text: 'Drugs', default_unit: '{n} gram | {n} grams'},
    cocaine: {text: 'Cocaine', unit:  '{n} gram | {n} grams'},
    heroin: {text: 'Heroin', unit: '{n} gram | {n} grams'},
    methamphetamine: {text: 'Meth', unit: '{n} gram | {n} grams'},
    ketamine: {text: 'Ketamine', unit: '{n} gram | {n} grams'},
    nimetazepam: {text: 'Nimetazepam', unit: '{n} gram | {n} grams'},
    ecstasy: {text: 'Ecstasy', unit: '{n} gram | {n} grams'},
    cannabisresin: {text: 'Cannabis Resin', unit: '{n} gram | {n} grams'},
    herbalcannabis: {text: 'Herbal Cannabis', unit: '{n} gram | {n} grams'},
    aggravate: {text: 'Aggravating Factors', unit: ' | +{n} month | +{n} months'},
    refugee: {text: 'Refugee/torture claimant', unit: ' | +{n} month | +{n} months'},
    bail: {text: 'Commission of the offence on bail', unit: ' | +{n} month | +{n} months'},
    street: {text: 'Trafficking in drugs on the street', unit: ' | +{n} month | +{n} months'},
    persistent: {text: 'Persistent offender', unit: ' | +{n} month | +{n} months'},
    international: {text: 'Cross-border trafficking', unit: ' | +{n} month | +{n} months'},
    aggravating_others: {text: 'Other aggravating factors', unit: ' | +{n} month | +{n} months'},
    //totalagg: {text: 'Total sentence added for aggravating factors', unit: ' | +{n} month | +{n} months'},
    sentence: {text: 'Sentence', unit: '{n} month | {n} months'},
    training_centre: 'Training Centre Order',
    detention_centre: 'Detention Centre Order',
    addiction_treatment_centre: 'Drug Addiction Treatment Centre Order',
    probation_order: 'Probation Order',
    rehabiltation_centre_order: 'Rehabiltation Centre Order',
    guilty_plea: {text: 'Guilty plea'},
    guilty_plea_stage: {text: 'Stage'},
    guilty_plea_sentence_str: {text: 'Discount', unit: '"{n}"'},  // string
    guilty_plea_sentence_month: {text: 'Discount', unit: '{n} month discount | {n} months discount'},  // months
    guilty_plea_sentence_percent: {text: 'Discount', unit: '{n}% discount'},  // percentage
    plea_not_guilty: 'Plead not guilty',
    high_unknown: 'Unknown',
    high_committal: 'Up to committal in Magistrates’ Courts',
    high_before_fix_trial_date: 'After committal and up to and until trial dates are fixed',
    high_before_trial: 'After trial dates are fixed but before the first date of trial',
    high_first_day: 'First day of trial',
    high_during_trial: 'During the trial',
    district_unknown: 'Unknown',
    district_plea_day: 'At plea day',
    district_before_trial: 'After trial dates are fixed but before the first date of trial',
    district_first_day: 'First day of trial',
    district_during_trial: 'During the trial',
    mitigate:  {text: 'Mitigating Factors'},
    remorse: {text: 'Remorse', unit: ' | −{n} month | −{n} months'}, 
    self_consume: {text: 'Self-consumption of significant proportion of drugs', unit: ' | −{n} month | −{n} months'},
    controlled_delivery: {text: 'Assistance to police/authorities', unit: ' | −{n} month | −{n} months'},
    testimony: {text: 'Assistance to police/authorities', unit: ' | −{n} month | −{n} months'},
    good_character: {text: 'Good character', unit: ' | −{n} month | −{n} months'},
    mitigating_others: {text: 'Other mitigating factors', unit: ' | −{n} month | −{n} months'},
    //mitigating_total_without_plea: {text: 'Total sentence redueced for mitigating factors, excluding guilt plea', unit: '{n} month | {n} months'},
    //mitigating_total_with_plea: {text: 'Total sentence reduced for mitigating factors, including guilty plea', unit: '{n} month | {n} months'},
    background: {text: 'Defendant Background'},
    foreigner: 'Foreigner',
    commission_age: {text: 'Age at commission of offence', unit: '{n}'},
    sentencing_age: {text: 'Age at sentencing', unit: '{n}'},
    extreme_youth: 'Extreme youth',
    previous_criminal_records: 'Previous criminal records',
    clear_record: 'Clear criminal record',
    starting_point: {text: 'Starting point', unit: '{n} month | {n} months'},
    single_charge_penalty: 'Sentence',
    penalty:  {text: 'Sentence'},
    unspecified: 'Unknown',
  }
}